import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import Constants from '../../constants';
import { AudienceSourceType, SurveyStatusType } from '../../models';
import { IApplicationState } from '../../store';
import { NavigationActions } from '../../store/NavigationActions';
import { SurveyPreviewActionCreators } from '../../store/SurveyPreviewActionCreators';
import { DistributionHelper } from '../../utilities/DistributionHelper';
import { UserFeatureAccessHelper } from '../FeatureFlags';

export const useSurveyAdminCards = (surveyId: number) => {
	const dispatch = useDispatch();
	const { surveyAdminSummary, surveyPreview, audiences } = useSelector((state: IApplicationState) => state.surveyAdmin);
	const { user } = useSelector((state: IApplicationState) => state.oidc);
	const userFeatureAccessHelper = new UserFeatureAccessHelper(user);
	const activeAudiences = audiences?.filter((a) => a.isTestAudience === false);

	const hasBeenPublished = surveyAdminSummary ? surveyAdminSummary.hasBeenPublished : false;
	const hasBeenCancelled = surveyAdminSummary ? surveyAdminSummary.surveyStatus === SurveyStatusType.Cancelled : false;
	const isClosed = _.every(activeAudiences, (a) => a.isClosed);
	const hasUniqueHrisAudienceDistribution = _.some(activeAudiences, (a) => {
		return DistributionHelper.isNotAnonymous(a.distributionType) && surveyAdminSummary?.audienceSourceType === AudienceSourceType.Hris;
	});

	const navigate = (subRoute: string) => () => {
		dispatch(NavigationActions.Navigate(Constants.ROUTE_SURVEY_ADMIN, surveyId, subRoute));
	};

	const previewSurvey = () => {
		if (!surveyPreview.previewUrl) {
			dispatch(SurveyPreviewActionCreators.PublishPreview(surveyId));
		} else {
			dispatch(SurveyPreviewActionCreators.PreviewSurvey(surveyPreview.previewUrl));
		}
	};

	return {
		userFeatureAccessHelper,
		hasBeenPublished,
		hasBeenCancelled,
		hasUniqueHrisAudienceDistribution,
		navigate,
		previewSurvey,
		isClosed,
	};
};
